/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
import _Vue from 'vue'

/**
 * vue-uuidのラッパーメソッド
 */
export default {
  /**
   * plugin登録時に実行される処理
   *
   * @param Vue Vueのコンストラクタ
   */
  install(Vue: typeof _Vue): void {
    /**
     * UUID(v4)の取得処理
     *
     * @returns UUID
     */
    const getUUID = function (): string {
      return Vue.prototype.$uuid.v4()
    }

    // プロトタイプ登録
    Vue.prototype.$getUUID = getUUID
  },
}

declare module 'vue/types/vue' {
  /**
   * 呼び出し時のインターフェース定義
   */
  interface Vue {
    /**
     * UUID(v4)の取得
     */
    $getUUID: () => string
  }
}
